import { Injectable } from '@angular/core';

import { Module } from '@core-interactions/models/module';
import { Account } from '@stores/models/app/account';
import { AccountType } from '@stores/models/app/account-type';

@Injectable()
export class ModuleClientService {
  hasAccess(module: Module, account: Account | null): boolean {
    if (!account || !module) {
      return false;
    }

    return (
      account.accountType === AccountType.SystemAdmin ||
      account.client?.modules?.includes(module.id) === true
    );
  }
}
